import React, { useState } from 'react';
import ScheduleModal from './ScheduleModal';
import { Button } from '@themesberg/react-bootstrap';

const ScheduleFormatter = ({ cell, row, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const formatScheduleSummary = (schedule) => {
    if (!schedule || !schedule.cronExpression) return 'Not Scheduled';
    const isSpecificHours = schedule?.cronExpression
      .split(' ')[2]
      .includes(':');
    const [minute, hour, , , daysOfWeek] = schedule.cronExpression.split(' ');
    const [startTime, endTime] = isSpecificHours && hour?.split(':');
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const timeDesc = isSpecificHours
      ? `from ${startTime} to ${endTime}`
      : `at ${hour}:${minute.padStart(2, '0')}`;
    const daysDesc =
      daysOfWeek === '*'
        ? 'every day'
        : daysOfWeek
            .split(',')
            .map((d) => dayNames[parseInt(d)])
            .join(', ');

    return `Runs ${timeDesc} on ${daysDesc}`;
  };

  return (
    <>
      <Button
        variant="link"
        onClick={() => setShowModal(true)}
        style={{
          padding: 0,
          textDecoration: 'none',
          maxWidth: '15rem',
          whiteSpace: 'wrap',
          textWrap: 'wrap',
        }}
      >
        {Object.keys(cell).length > 0 ? cell?.desc : 'Set Schedule'}
      </Button>
      <ScheduleModal
        show={showModal}
        onHide={() => setShowModal(false)}
        initialValue={cell || {}}
        onSave={(newSchedule) => {
          console.log('formatter', newSchedule);
          onUpdate(newSchedule);
          setShowModal(false);
        }}
        title="Edit Schedule"
      />
    </>
  );
};

export default ScheduleFormatter;
